import { render } from "./MarketPlace.vue?vue&type=template&id=9fa23f74&scoped=true"
import script from "./MarketPlace.vue?vue&type=script&lang=js"
export * from "./MarketPlace.vue?vue&type=script&lang=js"

import "./MarketPlace.vue?vue&type=style&index=0&id=9fa23f74&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/lostsailor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fa23f74"]])

export default __exports__